<template>
    <div class="row">

        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="principal">Principal Paid<star></star></label>
            <b-form-group id="principal" label-for="principal">
                <b-form-input class="mb-3 mt-2 field-container fields" type="number" step='any'
                    placeholder="Enter Principal Paid" v-model="form.principal"></b-form-input>
                <errors v-if="errors_msg.principal">
                    {{ errors_msg.principal[0] }}
                </errors>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="interest">Interest Paid<star></star></label>
            <b-form-group id="interest" label-for="interest">
                <b-form-input class="mb-3 mt-2 field-container fields" type="number" step='any'
                    placeholder="Enter Interest Paid" v-model="form.interest"></b-form-input>
                <errors v-if="errors_msg.interest">
                    {{ errors_msg.interest[0] }}
                </errors>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6"
            v-if="form.transaction_mode != 'Adjustment' && form.transaction_type == 'Loan Disbursed'">
            <label class="akkurate-dark small" for="principal_balance">Principal Balance<star></star></label>
            <b-form-group id="principal_balance" label-for="principal_balance">
                <b-form-input class="mb-3 mt-2 field-container fields" type="number" step='any'
                    placeholder="Enter Principal Balance" v-model="form.principal_balance"></b-form-input>
                <errors v-if="errors_msg.principal_balance">
                    {{ errors_msg.principal_balance[0] }}
                </errors>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6"
            v-if="form.transaction_mode != 'Adjustment' && form.transaction_type == 'Loan Disbursed'">
            <label class="akkurate-dark small" for="interest_balance">Interest Balance<star></star></label>
            <b-form-group id="interest_balance" label-for="interest_balance">
                <b-form-input class="mb-3 mt-2 field-container fields" type="number" step='any'
                    placeholder="Enter Interest Balance" v-model="form.interest_balance"></b-form-input>
                <errors v-if="errors_msg.interest_balance">
                    {{ errors_msg.interest_balance[0] }}
                </errors>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6">
            <b-form-group label-for="narration" class="mb-2">
                <template #label>
                    <label class="akkurate-dark small" for="narration">Narration</label>
                </template>
                <b-form-input class="mb-3 mt-2 field-container fields" type="text"
                    placeholder="Enter Transaction Description" v-model="form.narration"></b-form-input>
            </b-form-group>
            <errors v-if="errors_msg.credit">
                {{ errors_msg.narration[0] }}
            </errors>
        </div>

        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="transcation_date">Transaction Date <star></star></label>
            <b-form-group id="transcation_date" label-for="transcation_date">
                <b-form-input class="mt-2 field-container fields"
                     name="transcation_date" v-model="form.trans_date"
                    type="date"></b-form-input>
                <b-form-invalid-feedback>
                    The Trasaction Date field is required
                </b-form-invalid-feedback>
                <!-- <errors v-if="form.errors.trans_date">
                            {{ form.errors.trans_date[0] }}n
                        </errors> -->
            </b-form-group>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            errors_msg: {},
            coa_subhead: {},
            isSaving: false,

        }
    },
    props: {
        form: {
            required: true
        },
        add_or_edit: {
            require: true
        },
    },

}
</script>